<template>
  <Header />
  <div class="w-full font-basic text-text-0 mt-20">
    <!-- 상단 -->

    <div
      class="lg:mt-40 pb-10 lg:pb-24 text-medium-size lg:text-title-size font-basic text-white bg-black">

      <div class="border-t-4 border-main-0 "></div>

      <div
        class="px-10 lg:px-section mt-10 lg:mt-16 font-bold items-center text-content-size lg:text-title-size lg:leading-[52px]">
        <p>리드워크는</p>
        <p>SW 개발과 테스트 전문성을 결합한 차별화된 품질 경험을 제공합니다.</p>
      </div>
      <div class="mt-2 lg:mt-4"></div>

      <div class="px-10 lg:px-section">
        <p class="font-semibold text-content-size lg:text-medium-size up-animation-0">
          <span class="text-main-0 ">Lead</span> the way, <span class="text-main-0 ">Walk</span> together —
          리드워크
        </p>
        <div class=”hidden lg:block”>
          <p class=”mt-10 text-content-size  up-animation-1”>”기술로 길을 만들고, 신뢰로
            함께 걷다.”</p>
          <p class="text-content-size up-animation-1">리드워크는 SI 개발부터 품질(QA)까지 통합 수행하는 기술 중심 기업입니다.</p>
          <p class="mt-8 text-content-size  up-animation-2 lg:hidden">
            L-walk에는 급변화하는 IT 시장에서 QA 컨설팅과 다양한 경험을 갖춘 엔지니어들로 고객사의 신뢰하는 검증 서비스와 AR(증강현실)
            ,이미지 러닝 기술을 바탕으로 커머스 플랫폼 서비스 '겟아이즈'와 큐밋(런칭 준비중)으로 더 나은 미래를 향해 달려가고 있습니다.
          </p>
          <p class="mt-8 text-content-size up-animation-2 hidden lg:block">15년 이상 다수의 웹·앱·시스템 프로젝트를 수행하며,
            개발과 테스트를 아우르는 통합 서비스를 제공해왔습니다.
            <br>또한 B2B QA 아웃소싱 플랫폼 ‘큐밋’ 개발 및 운영 경험을 통해 사용자 중심의 품질 역량을 강화했습니다.
            <br>검증된 개발력과 QA 전문성으로 SW 프로젝트의 시작부터 완성까지 함께합니다.
          </p>
        </div>
      </div>

      <!-- 회사소개서 -->
      <div class="px-10 lg:px-section flex flex-col lg:flex-row gap-4 items-center up-animation-3 mt-8">

        <!-- 리드워크 회사 소개서 -->
        <a href="https://d2o04aboxunrcy.cloudfront.net/etc/202505/[리드워크] 회사소개서_2510_ff.pdf" download
          class="rounded-full flex items-center justify-center bg-main-0 py-4 px-4 lg:px-8">
          <p class="font-medium text-white text-small-size-1 lg:text-content-size">리드워크 회사
            소개서 다운 →</p>
        </a>

        <!-- 큐밋 서비스 소개서 -->
        <a href="https://d2o04aboxunrcy.cloudfront.net/etc/202505/[Qmeet]서비스소개서_2510_public.pdf" download
          class="rounded-full border-white border-[1px] flex items-center justify-center py-4 px-6 lg:px-8">
          <p class="font-medium text-white text-small-size-1 lg:text-content-size">큐밋 서비스
            소개 다운 →</p>
        </a>
      </div>

    </div>

    <!-- 리드워크 스토리 -->
    <div class="py-16 lg:py-24 bg-slate-50">
      <p class="font-semibold text-medium-size lg:text-title-size pl-[10%]">리드워크의 최신<br class="lg:hidden"> 소식을
        확인하세요</p>
      <div class="mx-10 mt-10">
        <Carousel class="" v-bind="settings" :autoplay="3000" :wrap-around="true" :items-to-scroll="1"
          :items-to-show="itemsToShow" :snap-align="center" :dir="ltr">
          <Slide class="" v-for="slide in slides" :key="slide">
            <CompanyStory :image="slide.image" :content="slide.content" :title="slide.title"
              :clickUrl="slide.clickUrl" />
          </Slide>

          <template #addons>
            <Navigation />
            <Pagination />
          </template>

        </Carousel>
      </div>
    </div>

    <div class="flex flex-wrap lg:flex-nowrap justify-center">
      <!-- 리드워크 발자취 -->
      <div class="pt-16 lg:pt-24 px-section overflow-auto">
        <p class="font-semibold text-medium-size lg:text-title-size">리드워크 발자취</p>
        <p class="mt-5 lg:mt-10 text-content-size lg:text-medium-size-1">
          리드워크는 열심히 역사를 만들고 있습니다.</p>
        <div class="flex h-[66vh] items-center justify-center px-6 md:px-60 relative mt-10">
          <div class="space-y-6 h-[66vh] border-l-2 border-solid absolute left-[40%] border-gray_3">
            <div v-for="(year, index) in Object.keys(companyHistoryData).reverse()" :key="year"
              class="w-full cursor-pointer" @click="handleClick(year)">
              <i :class="['absolute fa-regular fa-circle-dot bg-white z-8 -ml-[17px] fa-2x', selectedYear === year ? 'text-main-0' : 'text-main-1']"
                :style="{ top: 20 * index + '%' }"></i>
              <p :class="['absolute -ml-[80px] text-content-size font-semibold', selectedYear === year ? 'text-main-0' : 'text-main-1']"
                :style="{ top: 20 * index + '%' }">{{ year }}</p>
            </div>
          </div>
          <ul ref="yearData" class="ml-20 self-start absolute left-[40%]">
            <li v-for="item in currentYearData" :key="item.day" class="mb-10">
              <p>{{ item.day }}</p>
              <p>{{ item.content }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 찾아오는 길 -->
      <div class="py-16 lg:py-24 px-10 lg:px-section w-full lg:w-auto ">
        <p class="text-medium-size lg:text-title-size font-semibold">리드워크 찾아오는 길</p>
        <div class="mt-10"></div>
        <div class="flex text-small-size lg:text-content-size">
          <p class="font-semibold basis-[20%] lg:basis-[18%]">본사</p>
          <div class="flex flex-col">
            <p class="hidden lg:block">서울 금천구 디지털로 178</p>
            <p class="hidden lg:block">가산 퍼블릭 B동 10층 1014호</p>
          </div>
          <div class="lg:hidden">
            <p class="">서울 금천구 디지털로 178</p>
            <p class="">가산 퍼블릭 B동 10층 1014호</p>
          </div>
        </div>        
        <div class="flex lg:text-content-size mt-5">
          <p class="font-semibold basis-[20%] lg:basis-[18%]">Tel</p>
          <p class="">02-6953-8506</p>
        </div>
        <!-- 
        <div class="flex lg:text-content-size mt-5">
          <p class="font-semibold basis-[20%] lg:basis-[18%]">Fax</p>
          <p class="">02-2085-0607</p>
        </div>
        -->
        <div class="h-[600px] mt-10 mx-auto" id="map"></div>
      </div>
    </div>

    <CompanyHistory class="hidden" />

    <!-- 고객들과 함께 걸어간다. -->
    <p class="hidden mt-24 text-5xl font-semibold">고객들과 함께 걸어가고 있습니다.</p>

    <div class="flex-wrap items-center hidden gap-10 mt-20">
      <img class="w-[20%]" src="@/assets/ic_lg.jpg" alt="">
      <img class="w-[20%]" src="@/assets/ic_coway.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_oliveyoung.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_tmap.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_toss.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_vp.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_yesone.png" alt="">
      <img class="w-[20%]" src="@/assets/ic_yogiyo.png" alt="">
    </div>

    <div class="grid items-center hidden grid-cols-4 grid-rows-2 gap-5 mt-20">
      <img class="" src="@/assets/ic_lg.jpg" alt="">
      <img class="" src="@/assets/ic_coway.png" alt="">
      <img class="" src="@/assets/ic_oliveyoung.png" alt="">
      <img class="" src="@/assets/ic_tmap.png" alt="">
      <img class="" src="@/assets/ic_toss.png" alt="">
      <img class="" src="@/assets/ic_vp.png" alt="">
      <img class="" src="@/assets/ic_yesone.png" alt="">
      <img class="" src="@/assets/ic_yogiyo.png" alt="">
    </div>



  </div>
  <Footer />
</template>
<script>

import Header from '@/components/layoutComponents/Header.vue'
import Footer from '@/components/layoutComponents/Footer.vue'
import CompanyStory from '@/components/baseComponents/CompanyStory.vue'
import CompanyHistory from '@/components/baseComponents/CompanyHistory.vue'
import { BREAKPOINTS } from '@/constants/breakpoints'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import 'vue3-carousel/dist/carousel.css'

export default {
  components: {
    Header, Footer, CompanyHistory, CompanyStory, Carousel, Slide, Pagination, Navigation,
  },
  data() {
    return {
      //회사 히스토리 데이터
      companyHistoryData: {
        2020: [{ 'day': '2020. 01', 'content': '리드워크 법인설립' },
        { 'day': '2020. 01', 'content': '예비 창업 패키지 선정 (중소기업벤처부)' }
          , { 'day': '2020. 04', 'content': '벤처기업 승인 / 기술평가 우수 기업 인증 (T-5) / 연구 전담부서 설립' }
          , { 'day': '2020. 04', 'content': '증강현실 기술 특허출원 / 겟아이즈 상표등록출원' }
          , { 'day': '2020. 06', 'content': '20 초기 창업 패키지 선정, 중소기업벤처부' }
          , { 'day': '2020. 06', 'content': '겟아이즈 안드로이드 베타 서비스 출시' }
          , { 'day': '2020. 07', 'content': '19 예비 창업 패키지 최우수기업 선정, 중소기업벤처부' }
          , { 'day': '2020. 12', 'content': '장관상 수상 (과학기술정보통신부)' }
          , { 'day': '2020. 12', 'content': '시드 투자 유치 (두루그룹)' }],
        2021: [{ 'day': '2021. 01', 'content': '겟아이즈 안드로이드 정식 서비스 출시' }
          , { 'day': '2021. 01', 'content': '안드로이드, iOS 2차 베타 서비스' }
          , { 'day': '2021. 01', 'content': '겟아이즈 Ios 베타 서비스 출시' }
          , { 'day': '2021. 03', 'content': '리드워크 본사 확장 이전' }
          , { 'day': '2021. 05', 'content': '20 K-water IR 데모데이 최우수상 수상' }
          , { 'day': '2021. 06', 'content': '20 초기 창업 패키지 최우수기업 선정, 중소기업벤처부' }
          , { 'day': '2021. 06', 'content': '환경부 법정법인- 환경보전협회 회원사 등재' }
          , { 'day': '2021. 07', 'content': '겟아이즈 안드로이드 소프트 런칭' }
          , { 'day': '2021. 09', 'content': '겟아이즈, iOS 인기차트 21위 달성' }
        ],
        2022: [{ 'day': '2022. 01', 'content': '겟아이즈 (Get eyes) 상표등록' }],
        2023: [{ 'day': '2023. 03', 'content': '겟아이즈, 체험단 서비스 오픈' },
        { 'day': '2023. 09', 'content': '겟아이즈, 선물하기 서비스 오픈' },
        { 'day': '2023. 12', 'content': '큐밋 1차 베타 서비스 개발 시작' }],
        2024: [{ 'day': '2024. 09', 'content': '테스트센터 및 연구개발 전담부서 설립' },
              { 'day': '2024. 09', 'content': '큐밋 2차버전 개발 진행' }
        ],
        2025: [{ 'day': '2025. 03', 'content': '큐밋(Q-Meet) 플랫폼 런칭' },
        { 'day': '2025. 07', 'content': '큐밋, 오픈 4개월 만에 월간 B2B 고객 1.3만명 방문 달성' },
        { 'day': '2025. 10', 'content': '큐밋 스토어 오픈' }
        ],
      },
      selectedYear: '2025',

      // 윈도우의 너비를 추적합니다.
      windowWidth: window.innerWidth,

      slides: [
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_001.jpg', content: '겟아이즈는 이미지 인식 기술을 적용해 사용자가 제품을 즉시 등록할 수 있는 신규 기능을 출시했습니다.', title: '‘겟아이즈’ 이미지 인식 기반 제품 등록 기능 새롭게 선보여', clickUrl: 'https://www.itbiznews.com/news/articleView.html?idxno=49215' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_002.jpg', content: '리드워크가 운영하는 정보 플랫폼 ‘겟아이즈’는 두루그룹으로부터 시드 투자를 유치하며 성장 기반을 강화했습니다.', title: '정보 플랫폼 ‘겟아이즈’ 운영사 ‘리드워크’, 시드 투자유치', clickUrl: 'https://platum.kr/archives/154957' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_003.jpg', content: '리드워크는 다양한 테스트 서비스를 제공하기 위해 테스트 센터를 신설하고, 일반 기능 테스트부터 하드웨어 신뢰성 검증까지 수행할 수 있는 전문 테스트 환경을 구축했습니다.', title: "리드워크 테스트센터 및 연구개발 전담부서 신설", clickUrl: 'https://www.ilovepc.co.kr/news/articleView.html?idxno=35904' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_004.jpg', content: '리드워크는 국내 최초 B2B QA 전문 아웃소싱 플랫폼 ‘큐밋(Q-Meet)’을 개발·출시하며, QA 시장의 확장과 생태계 발전을 이끄는 플랫폼으로 자리매김하고 있습니다.', title: '국내 최초 QA 아웃소싱 플랫폼 ‘큐밋‘ 선보이다_큐밋 CEO 인터뷰', clickUrl: 'https://www.newseconomy.kr/news/articleView.html?idxno=17306' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_005.jpg', content: '‘큐밋(Q-Meet)’은 스마트테크 코리아 2025(STK 2025)에 참가해 기업 맞춤형 QA 아웃소싱과 솔루션 큐레이션 서비스를 선보였으며, 향후 AI 기반 솔루션 추천 기능을 도입해 고도화를 추진할 계획입니다.', title: 'QA 아웃소싱 매칭 및 솔루션 큐레이션 서비스 ‘큐밋’, ‘스마트테크 코리아 2025’ 참가', clickUrl: 'https://www.koreaiin.com/news/849510' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_006.jpg', content: '큐밋은 QA 코리아 컨퍼런스에 스폰서로 참여해 ‘전략적 QA 아웃소싱 파트너십 노하우’를 주제로 연사로 나섰습니다. ', title: '큐밋, 2025 QA 코리아 컨퍼런스 참가', clickUrl: 'https://www.q-meet.com/customer-case/65' },
        { image: 'https://d2o04aboxunrcy.cloudfront.net/etc/202505/lw_story_007.jpg', content: '큐밋은 자동화·AI·테스트 관리·보안 등 다양한 QA 솔루션을 손쉽게 비교·선택할 수 있는 ‘큐밋 스토어’를 추가 오픈하며, QA 전 과정을 아우르는 통합 플랫폼으로 확장했습니다.', title: '큐밋, 솔루션 스토어 공식 오픈', clickUrl: 'https://www.q-meet.com/customer-case/100' }
      ],
    }
  },
  created() {
    this._handleResize = () => { this.windowWidth = window.innerWidth; };
    window.addEventListener('resize', this._handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._handleResize);
  },
  computed: {
    itemsToShow() {
      // Tailwind의 반응형 유틸리티를 사용하여 클래스를 동적으로 변경
      return this.windowWidth >= BREAKPOINTS.LG ? '3' : '1';
    },
    currentYearData() {
      return this.companyHistoryData[this.selectedYear] || [];
    }
  },
  methods: {
    handleClick(year) {
      this.selectedYear = year;
      this.animateData();
    },
    animateData() {
      gsap.fromTo(this.$refs.yearData, { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.2 });

      let startYpos = 100;
      let duration = 0.6;
      let scrollStart = 'top 90%'
      gsap.registerPlugin(ScrollTrigger)
      gsap.fromTo(".up-animation-0",
        { y: startYpos, opacity: 0 }, // 시작 값
        {
          y: 0, // 종료 위치 (y축으로 100px 위로)
          delay: 0.2,
          opacity: 1, // 종료 투명도 (완전 불투명)
          duration: duration, // 애니메이션 지속 시간 1초
          ease: "power1.out", // 부드러운 애니메이션 효과
          // ScrollTrigger 설정
          scrollTrigger: {
            trigger: ".up-animation-0", // 이 애니메이션이 트리거 될 요소
            start: scrollStart, // 뷰포트의 상단에서 요소의 상단이 80% 지점에 도달했을 때 시작      
            toggleActions: "restart pause resume pause" // 스크롤 동작에 따른 애니메이션 제어
          }
        }
      );
      gsap.fromTo(".up-animation-1",
        { y: startYpos, opacity: 0 }, // 시작 값
        {
          y: 0, // 종료 위치 (y축으로 100px 위로)
          delay: 0.3,
          opacity: 1, // 종료 투명도 (완전 불투명)
          duration: duration, // 애니메이션 지속 시간 1초
          ease: "power1.out", // 부드러운 애니메이션 효과
          // ScrollTrigger 설정
          scrollTrigger: {
            trigger: ".up-animation-1", // 이 애니메이션이 트리거 될 요소
            start: scrollStart, // 뷰포트의 상단에서 요소의 상단이 80% 지점에 도달했을 때 시작      
            toggleActions: "restart pause resume pause" // 스크롤 동작에 따른 애니메이션 제어
          }
        }
      );
      gsap.fromTo(".up-animation-2",
        { y: startYpos, opacity: 0 }, // 시작 값
        {
          y: 0, // 종료 위치 (y축으로 100px 위로)
          delay: 0.4,
          opacity: 1, // 종료 투명도 (완전 불투명)
          duration: duration, // 애니메이션 지속 시간 1초
          ease: "power1.out", // 부드러운 애니메이션 효과
          // ScrollTrigger 설정
          scrollTrigger: {
            trigger: ".up-animation-2", // 이 애니메이션이 트리거 될 요소
            start: scrollStart, // 뷰포트의 상단에서 요소의 상단이 80% 지점에 도달했을 때 시작      
            toggleActions: "restart pause resume pause" // 스크롤 동작에 따른 애니메이션 제어
          }
        }
      );
      gsap.fromTo(".up-animation-3",
        { y: startYpos, opacity: 0 }, // 시작 값
        {
          y: 0, // 종료 위치 (y축으로 100px 위로)
          delay: 0.5,
          opacity: 1, // 종료 투명도 (완전 불투명)
          duration: duration, // 애니메이션 지속 시간 1초
          ease: "power1.out", // 부드러운 애니메이션 효과
          // ScrollTrigger 설정
          scrollTrigger: {
            trigger: ".up-animation-3", // 이 애니메이션이 트리거 될 요소
            start: scrollStart, // 뷰포트의 상단에서 요소의 상단이 80% 지점에 도달했을 때 시작      
            toggleActions: "restart pause resume pause" // 스크롤 동작에 따른 애니메이션 제어
          }
        }
      );
    },
  },
  mounted() {
    //this.animateData(); // 초기 애니메이션

    //네이버 지도 api 로드
    const script = document.createElement("script");
    script.src = "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=nd9f34b6hi";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.onload = () => {
      // 네이버 지도 생성
      let map = new window.naver.maps.Map("map", {
        center: new window.naver.maps.LatLng(37.477315527564, 126.8866589209),
        zoom: 17,
      });

      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(37.477315527564, 126.8866589209),
        map: map
      });
    };
  }
}
</script>
